import React from 'react';

export const NewsletterThumbnail = ({ canvasData, width = 280 }) => {
  const blocks = canvasData?.blocks || [];
  if (!blocks.length) return null;

  const scale = width / 600;
  const height = Math.min(width * 1.2, 340);

  return (
    <div
      className="overflow-hidden"
      style={{ width, height, position: 'relative' }}
      data-testid="newsletter-thumbnail"
    >
      <div
        style={{
          transform: `scale(${scale})`,
          transformOrigin: 'top left',
          width: 600,
          fontFamily: 'Arial, sans-serif',
          pointerEvents: 'none',
        }}
      >
        {blocks.map((block, i) => (
          <MiniBlock key={block.id || i} block={block} />
        ))}
      </div>
      {/* Fade at bottom */}
      <div style={{
        position: 'absolute', bottom: 0, left: 0, right: 0, height: '40px',
        background: 'linear-gradient(transparent, rgba(255,255,255,0.95))',
      }} />
    </div>
  );
};

const MiniBlock = ({ block }) => {
  switch (block.type) {
    case 'header':
      return (
        <div style={{ backgroundColor: block.backgroundColor, color: block.textColor, padding: `${block.padding * 0.6}px`, textAlign: 'center' }}>
          <div style={{ fontSize: '20px', fontWeight: 'bold', fontFamily: 'Georgia, serif', margin: '0 0 4px' }}>{block.title}</div>
          {block.subtitle && <div style={{ fontSize: '12px', opacity: 0.85 }}>{block.subtitle}</div>}
        </div>
      );
    case 'text':
      return (
        <div style={{ backgroundColor: block.backgroundColor || '#fff', padding: `${(block.padding || 20) * 0.5}px`, fontSize: '10px', color: block.textColor, lineHeight: 1.4 }} dangerouslySetInnerHTML={{ __html: block.content }} />
      );
    case 'image':
      return (
        <div style={{ padding: `${(block.padding || 0) * 0.5}px`, textAlign: block.alignment || 'center' }}>
          {block.imageUrl ? (
            <img src={block.imageUrl} alt="" style={{ width: '100%', maxHeight: '120px', objectFit: 'cover' }} />
          ) : (
            <div style={{ background: '#F3F4F6', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ width: '28px', height: '28px', borderRadius: '50%', background: '#E5E7EB', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ fontSize: '16px', color: '#9CA3AF' }}>+</span>
              </div>
            </div>
          )}
        </div>
      );
    case 'button':
      return (
        <div style={{ padding: `${(block.padding || 20) * 0.5}px`, textAlign: block.alignment || 'center' }}>
          <span style={{ display: 'inline-block', backgroundColor: block.backgroundColor, color: block.textColor, padding: '6px 20px', borderRadius: `${block.borderRadius || 4}px`, fontSize: '11px', fontWeight: 'bold' }}>{block.text}</span>
        </div>
      );
    case 'divider':
      return (
        <div style={{ padding: `${(block.padding || 10) * 0.4}px` }}>
          <hr style={{ border: 'none', borderTop: `${block.thickness}px solid ${block.color}`, margin: 0 }} />
        </div>
      );
    case 'spacer':
      return <div style={{ height: `${(block.height || 20) * 0.5}px` }} />;
    case 'footer':
      return (
        <div style={{ backgroundColor: block.backgroundColor, color: block.textColor, padding: `${(block.padding || 20) * 0.4}px`, textAlign: 'center', fontSize: '8px' }}>
          {block.signatureName && <div style={{ fontWeight: 'bold' }}>{block.signatureName}</div>}
          {block.showUnsubscribe && <div style={{ marginTop: '4px', opacity: 0.6 }}>{block.unsubscribeText}</div>}
        </div>
      );
    default:
      return null;
  }
};

export default NewsletterThumbnail;
